import { UpdateSaleDate } from "../client/types.gen";
import { CreatedSale, CreateSale, Sale, SalePage, SearchGetManySalesQueryParams, UpdateSale } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithEdit } from "./mixins/WithEdit";
import { WithGet } from "./mixins/WithGet";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

export class Endpoint extends BaseEndpoint("sales") {
  getHistory(id: string): Promise<Sale[]> {
    return this.request(`${id}/history`);
  }

  updateDate(id: string, body: UpdateSaleDate): Promise<Sale> {
    return this.request(`${id}/date`, {
      method: "PATCH",
      body,
    });
  }
}

const withGetOne = WithGet<typeof Endpoint, Sale>(Endpoint);

const withGetAll = WithSearchableGetPage<typeof withGetOne, Sale, SalePage, SearchGetManySalesQueryParams>(withGetOne);

// `POST /sales` répond une `CreatedSale` (champs serveur seulement), pas la vente complète.
export const SaleEndpoint = WithEdit<typeof withGetAll, Sale, CreateSale, UpdateSale, CreatedSale>(withGetAll);
